import { SelectColumnFilter } from '../../virtualized-table/components/filter';
import { VirtualTableHeadCell } from '../../virtualized-table/types';

export const softwareHeadCells: VirtualTableHeadCell[] = [
  {
    accessor: 'fileName',
    Header: 'File Name',
    maxWidth: 2500,
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
    width: 150,
  },
  {
    accessor: 'createdTime',
    Header: 'Upload Date #',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
    width: 180,
  },
  {
    accessor: 'createdBy',
    Header: 'User ID',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'partNumber',
    Header: 'Part Number',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
    width: 150,
  },
  {
    accessor: 'fileTypeId',
    Header: 'File Type',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
    width: 150,
  },
  {
    accessor: 'id',
    Header: 'SHA',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
    width: 150,
  },
];

export const softwareHeadCellsAccessors = {
  fileName: true,
  createdTime: true,
  createdBy: true,
  partNumber: true,
  fileTypeId: true,
  id: true,
};
